import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const RevertEditorDialog: LoadableType<{
	contentId: string;
	onPageRevert?: () => void;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RevertEditorDialog" */ '../src/EditorRevert/RevertEditorDialog.tsx'
			)
		).RevertEditorDialog,
});
